/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADER
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	loader: {
        color: '#fff',
        // opacity: '0',
        // animationName: 'fadeIn',
        // animationDelay: '.3s',
        // animationDuration: '.3s',
        // animationFillMode: 'forwards',
        '& .loaderContainer': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
        }
    }
};